import { render, staticRenderFns } from "./ImageSwiper.vue?vue&type=template&id=2e647f08&"
import script from "./ImageSwiper.vue?vue&type=script&lang=js&"
export * from "./ImageSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports